// Dynamic display currency label by UI language.
// RO/EN market uses RON; IT/DE/FR/ES use the euro sign.
const CURRENCY_BY_LANG = { ro: "RON", en: "RON", it: "€", de: "€", fr: "€", es: "€" };

export function currencyLabel(lang) {
  const base = (lang || "ro").split("-")[0];
  return CURRENCY_BY_LANG[base] || "RON";
}
